// Menyen i Pulse, etter menyen i Amo Ctrl (Håvard 16.10.2026, tatt inn i
// Pulse 18.10.2026): søket, Favoritter-gruppa og regelen for aktivt punkt.
// Rene funksjoner over seksjonene fra getNavSections (Sidebar.jsx), som
// allerede er filtrert på tilgang. Søket og favorittene filtrerer bare videre
// i dem, så de kan aldri vise et punkt brukeren ellers ikke ser.

export const MIN_SIDE = '/min-side'

/** Små bokstaver og enkle mellomrom, så «  Lager  &  WMS» treffer «lager & wms». */
export const normaliserSok = s => String(s || '').toLocaleLowerCase('nb').replace(/\s+/g, ' ').trim()

/**
 * Treffer søket punktet? Hvert ord må finnes i gruppenavnet eller etiketten,
 * så «økonomi» gir hele Økonomi-gruppa og «økonomi bal» bare Balanse.
 */
export function menyTreff(sok, gruppe, punkt) {
  const ord = normaliserSok(sok).split(' ').filter(Boolean)
  if (!ord.length) return true
  const tekst = normaliserSok(`${gruppe || ''} ${punkt.label}`)
  return ord.every(o => tekst.includes(o))
}

/** Seksjonene med bare punktene som treffer søket. Tomme seksjoner faller bort. */
export function filtrerMeny(seksjoner, sok) {
  return seksjoner
    .map(s => ({ ...s, items: s.items.filter(it => menyTreff(sok, s.label, it)) }))
    .filter(s => s.items.length)
}

const utenSkraastrek = sti => (sti.length > 1 ? sti.replace(/\/+$/, '') : sti)

/**
 * Menypunktet en adresse er, for stjerna: bare et eksakt treff, så
 * /crm/quotes/42 ikke kan legges i favoritter som Tilbud.
 */
export function punktForSti(seksjoner, sti) {
  const s = utenSkraastrek(sti || '')
  for (const seksjon of seksjoner) {
    const punkt = seksjon.items.find(it => it.path === s)
    if (punkt) return punkt
  }
  return null
}

/**
 * Står brukeren på punktet? Samme regel som NavLink i menyen: Dashboard og
 * kundenes Dashboard bare på sin egen adresse, de andre også under stien. En
 * sammenlagt gruppe viser dermed fortsatt siden man er på.
 */
export function erAktivtPunkt(punkt, sti) {
  if (punkt.path === '/' || punkt.path === '/kunde') return sti === punkt.path
  return sti === punkt.path || sti.startsWith(`${punkt.path}/`)
}

/**
 * Favoritter øverst i menyen: Min side først når brukeren har den, så
 * favorittene i den rekkefølgen de ble merket. Bare punkter som står i menyen
 * nå, så en side man har mistet tilgang til, forsvinner også herfra.
 */
export function favorittpunkter(seksjoner, favoritter) {
  const alle = new Map(seksjoner.flatMap(s => s.items).map(it => [it.path, it]))
  const punkter = []
  if (alle.has(MIN_SIDE)) punkter.push(alle.get(MIN_SIDE))
  for (const sti of favoritter || []) {
    const punkt = alle.get(sti)
    if (punkt && !punkter.includes(punkt)) punkter.push(punkt)
  }
  return punkter
}

/** Legger verdien til sist, eller tar den bort når den finnes. */
export function veksle(liste, verdi) {
  return liste.includes(verdi) ? liste.filter(x => x !== verdi) : [...liste, verdi]
}

/** Et felt der «/» er et vanlig tegn og ikke snarveien til menysøket. */
export const erSkrivefelt = el =>
  !!el && (el.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(el.tagName))
